import { render, staticRenderFns } from "./EditLeaveTypeForm.vue?vue&type=template&id=35e1823a&"
import script from "./EditLeaveTypeForm.vue?vue&type=script&lang=js&"
export * from "./EditLeaveTypeForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports